import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_API_URL,
});

axiosInstance.interceptors.request.use(
    function (config) {
        // Append token to request authorization header if available
        const access_token = localStorage.getItem("access_token");
        if (access_token) {
            (config.headers as any) = {
                ...config.headers,
                authorization: `Bearer ${access_token}`,
            };
        }

        return config;
    },
    function (error){
        return Promise.reject(error);
    }
);

export default axiosInstance;